import { useMemo } from 'react';
import {
  MyAnalyticsQuery,
  MyAnalyticsDimensionType,
  useMyAnalyticsQuery
} from 'graphql/types';
import { useNoteInsightsContext } from '../NoteInsightsContextProvider';
import { useGetPreviousPeriod } from './useGetPreviousPeriod';

export const useGetPreviousAnalyticsData = (
  dimension: MyAnalyticsDimensionType
): {
  data: MyAnalyticsQuery | undefined;
  loading: boolean;
  prevStartDate: string;
} => {
  const { currentPeriod, selectedViewOption } = useNoteInsightsContext();

  const { prevStartDate, prevEndDate } = useGetPreviousPeriod({
    currentPeriod,
    selectedViewOption
  });
  const { loading, data } = useMyAnalyticsQuery({
    variables: {
      input: {
        dimension,
        dateRange: {
          fromDate: prevStartDate,
          toDate: prevEndDate
        }
      }
    }
  });
  return useMemo(
    () => ({
      data,
      loading,
      prevStartDate
    }),
    [data, loading, prevStartDate]
  );
};
